"use client";

import ReactQueryProvider from "@/setup/react-query";
import { ToastProvider } from "@/context/ToastProvider";
import { ToastContainer } from "react-toastify";
import { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";

export default function Providers({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <ReactQueryProvider>
      <ToastProvider>
        {children}
        {mounted && <ToastContainer position="top-center" />}
      </ToastProvider>
    </ReactQueryProvider>
  );
}
